<template>
  <iframe
    width="100%"
    height="100%"
    frameborder="0"
    scrolling="no"
    marginheight="0"
    marginwidth="0"
    :src="embedMapLink"
  />
</template>
<script lang="ts">
import { useLocation } from '@/core/composable/shared/useLocation'
import { type SpaLocation } from '~/core/ts/entity/Spa'

export default defineNuxtComponent({
  props: {
    location: {
      type: Object as PropType<SpaLocation>,
      required: true,
    },
  },
  setup(props) {
    const { embedMapLink } = useLocation(props.location)
    return {
      embedMapLink,
    }
  },
})
</script>
